/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineBotExamReviewViewModel } from "../types/ClassroomDisciplineBotExamReviewViewModel.ts";
import { botExamReviewQuestionViewModelSchema } from "./botExamReviewQuestionViewModelSchema.ts";

export const classroomDisciplineBotExamReviewViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da prova bot gerada para revisão."),
  ),
  botExamLangId: z.optional(
    z.number().int().describe("ID do idioma da prova bot associado à revisão."),
  ),
  title: z
    .string()
    .describe("Título da prova bot para revisão. Opcional.")
    .nullish(),
  instruction: z
    .string()
    .describe("Instrução geral da prova bot exibida ao revisor. Opcional.")
    .nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  questions: z
    .array(z.lazy(() => botExamReviewQuestionViewModelSchema))
    .describe("Lista de questões da prova bot para revisão.")
    .nullish(),
}) as unknown as ToZod<ClassroomDisciplineBotExamReviewViewModel>;
